import React, { useEffect } from "react";

export default function MechtronGate() {
  useEffect(() => {
    if (!sessionStorage.getItem("local_app_loginDetails")) {
      window.location.href = "/login";
    }

    const interval = setInterval(() => {
      if (!sessionStorage.getItem("local_app_loginDetails")) {
        document.body.innerHTML = `
          <div style="text-align:center;margin-top:100px">
            <h2>Session expired</h2>
            <a href="/">Return to login</a>
          </div>
        `;
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
  <iframe
  src="/Mechatron_3456321/index2.html"
  style={{ width: "100vw", height: "100vh", border: "none" }}
  title="Mechatron Simulation"
/>

  );
}
